import React, { Component } from 'react';
import classnames from 'classnames';
//utils
import {translateStatus} from '../../../utils';

export default class CaseBodyProductListStatus extends Component{
  render(){
    let statusIcon = classnames({
      'gdocs-gdocs-float-left icon icon-circle-error-solid case-in-progress-icon': this.props.status === 'incomplete',
      'gdocs-gdocs-float-left icon icon-circle-confirmation-solid no-conflict-icon': this.props.status === 'complete'
    });
    return(
      <div className='rightContent gdocs-ptop-15'>
      <span className="case-status">{translateStatus(this.props.lang,this.props.status)}</span>
      <div className={statusIcon}></div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/NavigationList/CaseBodyProductListStatus.js